import React from 'react';
import { useState, useEffect } from "react";
import StrokeMenu from './StrokeMenu';
import ColorMenu from './ColorMenu';
import { useSelector } from 'react-redux';
// import getCanvasSize from '../../../../../redux/canvasSize/canvasSizeSlice';
import './ShapeMenu.scss'

export default function ShapeMenu(props) {
    const [isShapeSelected, setIsShapeSelected] = useState(false);
    const [isStrokeBtnActive, setIsStrokeBtnActive] = useState(false);
    const [isColorBtnActive, setIsColorBtnActive] = useState(false);
    const [shapeCurrentColor, setShapeCurrentColor] = useState('#000');
    const [shapeMenuCoords, setShapeMenuCoords] = useState({x: 100, y: 100});
    const [selectedShape, setSelectedShape] = useState([0, 0]);
    const [shapeXcoord, setShapeXcoord] = useState(0);
    const [shapeYcoord, setShapeYcoord] = useState(0);

    // const canvasSize = useSelector(getCanvasSize);
    
    const currentReticleSize = useSelector((state) => state.canvasSize.canvasSizes);
    const activeTabId = useSelector((state) => state.tabs.activeTabId);

    const handleDelete = () => {
        props.deleteShape();
    }

    const handlerDuplicate = () => {
        props.duplicateShape(props.selectedShape, true);
    }

    const handlerStroke = () => {
        setIsStrokeBtnActive(!isStrokeBtnActive);
        setIsColorBtnActive(false);
    }

    const handlerColor = () => {
        setIsStrokeBtnActive(false);
        setIsColorBtnActive(!isColorBtnActive);
    }

    const hendlerRotatePlus = () => {
        setIsStrokeBtnActive(false);
        setIsColorBtnActive(false);
		props.rotateShape(props.selectedShape, 'rotateRight');
	}

	const hendlerRotateMinus = () => {
        setIsStrokeBtnActive(false);
        setIsColorBtnActive(false);
		props.rotateShape(props.selectedShape, 'rotateLeft');
	}

    const handlerUpdateShapeCurrentColor = (color) => {
        setShapeCurrentColor(color);
    }

    useEffect(() => {
        props.selectedShapes.length ? setIsShapeSelected(true) : setIsShapeSelected(false);
    
        if (props.selectedShapes && props.selectedShapes.length > 1) {
            setShapeCurrentColor(props.selectedShapes[0].fill());
        } else {
            if (props.selectedShape) {
                setShapeCurrentColor(props.selectedShape.fill());
                setShapeMenuCoords({x: props.selectedShape.x(), y: props.selectedShape.y()});
            }
        }

        if (!isShapeSelected) {
            setIsStrokeBtnActive(false);
            setIsColorBtnActive(false);
        }
    }, [props.selectedShape, props.selectedShapes]);

    useEffect(() => {
        try {
            if (currentReticleSize[activeTabId]) {
                let w = currentReticleSize[activeTabId][0];
                let h = currentReticleSize[activeTabId][1];
    
                if (props.selectedShape) {
                    setSelectedShape([props.selectedShape.x(), props.selectedShape.y()]);
                    setShapeXcoord(Math.abs(props.selectedShape.x() - (w / 2 + 48)));
                    setShapeYcoord(Math.abs(props.selectedShape.y() - (h / 2 + 55)));
                }
            }
        } catch(e) {
            console.log(e)
        }
    }, [props])

    return (
        currentReticleSize[activeTabId] && (
            <section id='shapeMenu' className={isShapeSelected ? 'shape-menu-section visible-shape-menu' : 'shape-menu-section'} style={{top: selectedShape[1] >= currentReticleSize[activeTabId][1] / 2 ? `calc(50% + ${shapeYcoord}px)` : `calc(50% - ${shapeYcoord}px)`, left: selectedShape[0] >= currentReticleSize[activeTabId][0] / 2 ? `calc(50% + ${shapeXcoord}px)` : `calc(50% - ${shapeXcoord}px)`}}>
                <div className='shape-menu-block'>
                    <button className='shape-menu-delete-btn' onClick={handleDelete}></button>
                    <button className='shape-menu-duplicate-btn' onClick={handlerDuplicate}></button>
                    <button className='shape-menu-stroke-btn' onClick={handlerStroke}>
                        {isStrokeBtnActive &&
                            <StrokeMenu selectedShape={props.selectedShape} selectedShapes={props.selectedShapes} />
                        }
                    </button>
                    {props.selectedShape.type !== 'line' &&
                        <button className='shape-menu-color-btn' onClick={handlerColor} style={{marginRight: (props.selectedShape.type === 'polygon' || props.selectedShape.type === 'line') ? '14px' : 0}}>
                            <span className='shape-menu-current-color' style={{backgroundColor: shapeCurrentColor}}>
                                {isColorBtnActive &&
                                    <ColorMenu selectedShape={props.selectedShape} selectedShapes={props.selectedShapes} updateIconColor={handlerUpdateShapeCurrentColor} />
                                }
                            </span>
                        </button>
                    }
                    {(props.selectedShape.type === 'polygon' || props.selectedShape.type === 'line') &&
                        <>
                            <button className='shape-menu-rotate-button shape-menu-rotate-btn_plus' onClick={hendlerRotatePlus}></button>
                            <button className='shape-menu-rotate-button shape-menu-rotate-btn_minus' onClick={hendlerRotateMinus}></button>
                        </>
                    }
                </div>
            </section>
        )
    )
}
